import Index from '../components/ApiErrorLog/Index.vue'

let routes = {
    path: '/api-error-logs',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/api-error-logs',
            name: 'Logs de Erros da API',
            component: Index
        },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/api-error-logs.js